import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";

const { Select2, Date, DateTime, Text } = Inputs;

function Landing({history}) {
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      history.push("/logout");
    }
  }, []);
  return (
    <Content
      title="Bienvenido"
      browserTitle="Bienvenido a Agendia"
      show={false}
    ></Content>
  );
}

export default Landing;
